/* tslint:disable */
/* eslint-disable */
/**
 * authentik
 * Making authentication simple.
 *
 * The version of the OpenAPI document: 2024.12.3
 * Contact: hello@goauthentik.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the ErrorReportingConfig interface.
 */
export function instanceOfErrorReportingConfig(value) {
    if (!('enabled' in value) || value['enabled'] === undefined)
        return false;
    if (!('sentryDsn' in value) || value['sentryDsn'] === undefined)
        return false;
    if (!('environment' in value) || value['environment'] === undefined)
        return false;
    if (!('sendPii' in value) || value['sendPii'] === undefined)
        return false;
    if (!('tracesSampleRate' in value) || value['tracesSampleRate'] === undefined)
        return false;
    return true;
}
export function ErrorReportingConfigFromJSON(json) {
    return ErrorReportingConfigFromJSONTyped(json, false);
}
export function ErrorReportingConfigFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'enabled': json['enabled'],
        'sentryDsn': json['sentry_dsn'],
        'environment': json['environment'],
        'sendPii': json['send_pii'],
        'tracesSampleRate': json['traces_sample_rate'],
    };
}
export function ErrorReportingConfigToJSON(json) {
    return ErrorReportingConfigToJSONTyped(json, false);
}
export function ErrorReportingConfigToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {};
}
